import fullscreen1 from './fullscreen1';
import fullscreen2 from './fullscreen2';
import titleBar from './titleBar';
import l3Two from './l3Two';
import ticker from './ticker';

export default {
  fullscreen1,
  fullscreen2,
  titleBar,
  l3Two,
  ticker,
};
